import React, { FC } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";

import { TextInput } from "@/components/atoms";
import { RefSelectInput } from "@/components/molecules";

import { CustomerCardFormType } from "../../../../../formType";
import AddressFields from "../../../components/AddressFields/AddressFields";

const PersonalInfo: FC = () => {
    const { control } = useFormContext<CustomerCardFormType>();
    const { t } = useTranslation();
    return (
        <Grid container>
            <Grid item xs={12}>
                <TextInput
                    name="personal.lastName"
                    label={t("Common.Name")}
                    required
                    autoComplete="off"
                    control={control}
                />
            </Grid>
            <Grid item xs={12}>
                <RefSelectInput name="personal.legalState.id" control={control} table="legalStatus" />
            </Grid>
            <AddressFields />
            <Grid item xs={12}>
                <TextInput
                    name="companyInfo.bceNumber"
                    label={t("CustomerCard.PersonalInfo.BCE")}
                    autoComplete="off"
                    control={control}
                />
            </Grid>
            <Grid item xs={12}>
                <TextInput
                    name="companyInfo.establishmentNumber"
                    label={t("CustomerCard.PersonalInfo.EstablishmentNumber")}
                    autoComplete="off"
                    control={control}
                />
            </Grid>
        </Grid>
    );
};

export default PersonalInfo;
